import { ActionProcessMode } from '@infotech-soe/metaschema';

import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommandImpl from './CategoryCommandImpl';

class LinkedFilesCommandImpl extends CategoryCommandImpl<Record<string, any>> {
  constructor() {
    super();
  }

  public async execute(): Promise<void> {
    return;
  }

  public getUserInteractor(): UserInteractor {
    return {
      type: UserInteractorType.SHOW_CATEGORY,
      category: 'AttachedFiles',
      displayMode: 'main',
      action: 'ShowAttachedFiles',
      dataset: 'AttachedFiles',
      multiSelect: false,
      hideTree: false,
      fullHierarchy: false,
      hideCheckbox: false,
    };
  }

  public async getInitialArgs(
    context: ClientContext
  ): Promise<Record<string, any>> {
    return {
      inParams: {
        selDocument: context.get('Id'),
        selCategory: context.get('Category'),
      },
    };
  }

  public getName(): CommandName {
    return 'linkedFiles';
  }

  public getProcessMode(): ActionProcessMode {
    return 'Current';
  }
}

export default LinkedFilesCommandImpl;
